require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-as-ida-aligns-its-operations-with-the-corporate-scorecard.json") })
        }
      }, "path---en-us-update-as-ida-aligns-its-operations-with-the-corporate-scorecard");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-as-ida-aligns-its-operations-with-the-corporate-scorecard!./.cache/json/en-us-update-as-ida-aligns-its-operations-with-the-corporate-scorecard.json
// module id = 614
// module chunks = 231608221292675